import { Link } from "react-router-dom";
import { Crown, Handshake, Radio } from "lucide-react";
import { DIVISIONS } from "../../lib/heritage";
import { DgcEmblem } from "../Logo";

const pillFor = (o) => (o === "DGC" ? "pill-green" : o === "Kennedy Osei" ? "pill-blue" : "pill-gold");

const Person = ({ icon: I, title, name, note, gold, testId, slug, photo }) => (
  <Link to={`/people/${slug}`} className={`panel panel-hover block px-6 py-5 text-center w-full max-w-sm ${gold ? "border-2 !border-[color:var(--gold-hi)]" : ""}`} data-testid={testId}>
    {photo ? <img src={photo} alt={name} className="w-20 h-20 mx-auto rounded-full object-cover object-top gold-frame-sm" /> : <I size={18} className="mx-auto text-[color:var(--gold)]" />}
    <div className="font-data text-[10px] uppercase tracking-[0.2em] text-brand-green mt-2">{title}</div>
    <div className="font-display text-lg text-ink font-bold mt-1">{name}</div>
    {note && <div className="text-[11px] text-ink-3 mt-1">{note}</div>}
    <div className="font-data text-[9px] uppercase tracking-wider text-brand-green mt-2">View bio →</div>
  </Link>
);

export const OrgChart = ({ compact }) => (
  <div data-testid="org-chart">
    <div className="flex flex-col items-center">
      <DgcEmblem size={compact ? 72 : 96} />
      <div className="w-px h-6 bg-[color:var(--gold-hi)]" />
      <div className="grid md:grid-cols-[1fr_auto_1fr] items-center gap-4 w-full max-w-3xl justify-items-center">
        <Person icon={Crown} gold photo="/brand/dr-despite.jpg" title="Founder & Chairman" slug="osei-kwame-despite" name="Dr. Osei Kwame Despite" note="Despite Group of Companies (DGC)" testId="org-founder" />
        <div className="flex md:flex-col items-center gap-1 text-[color:var(--gold)]"><Handshake size={18} /><span className="font-data text-[9px] uppercase tracking-widest">Partners</span></div>
        <Person icon={Handshake} gold photo="/brand/dr-ofori-sarpong.png" title="Co-founder & Partner" slug="ernest-ofori-sarpong" name="Dr. Ernest Ofori Sarpong" note="Special Group · UTV · U2 Salt · Best Point (Board Chairman) · Best Assurance · Best Pensions · Special Ice" testId="org-partner" />
      </div>
      <div className="w-px h-6 bg-[color:var(--gold-hi)]" />
      <Person icon={Radio} photo="/brand/kennedy-osei.jpg" title="General Manager" slug="kennedy-osei" name="Kennedy Osei" note="Despite Media Group · Golden Crest Hotel" testId="org-gm" />
      <div className="w-px h-6 bg-[color:var(--gold-hi)]" />
      <div className="h-px w-full max-w-5xl bg-[color:var(--gold-hi)]/70" />
    </div>
    <div className={`grid sm:grid-cols-2 ${compact ? "lg:grid-cols-3" : "lg:grid-cols-6"} gap-3 mt-6`}>
      {DIVISIONS.map((d) => (
        <div key={d.name} className="panel p-4 border-t-4 !border-t-[color:var(--green)]" data-testid={`division-${d.name.toLowerCase().replace(/\W+/g, "-")}`}>
          <div className="font-display text-base font-bold text-ink">{d.name}</div>
          <div className="text-[10px] text-ink-3 mb-3">{d.lead}</div>
          <div className="space-y-2">
            {d.items.map(([n, e, o, slug]) => (
              <Link key={n} to={`/entities/${slug}`} className="block bg-[#F4F8F5] rounded px-2.5 py-2 border border-transparent hover:border-[color:var(--gold-hi)] transition-colors" data-testid={`org-entity-link-${slug}`}>
                <div className="text-[13px] text-ink font-semibold leading-tight">{n}</div>
                <div className="text-[10px] text-ink-3">{e}</div>
                <span className={`pill ${pillFor(o)} mt-1 !text-[9px]`}>{o}</span>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
